<div class="section-title section-title--culture">
    <h2>Remove Saved Payment Card</h2>
</div>

<div class="content content--terms" style="grid-gap: 10px 0px; max-width: 1210px;">

    <p>SGC does not directly store or handle your payment method information, including credit card number, cardholder name, expiration date, or CSC. To access a previously saved payment method, you can use our credit card processor's tool on the checkout page of an order or contact our Customer Support team [<a routerLink="/collector-support/contact-us">link</a>].</p>

    <p>To delete your payment method data held by our processor, follow the steps below.</p>
    

    <h2 class="mbl-60">Web</h2>
    <p><strong>1.</strong>  Login to gosgc.com and start an order or continue a draft order.</p>
    <p><strong>2.</strong>  On “Step 7 - Payment” step in the order process, locate the stored payment methods section above the “PAY NOW WITH SAVED CARD” button.</p>
    <p><strong>3.</strong> On the Payment Method you want to remove, locate the row and click the red “REMOVE” button.</p>
    <div>
        <img class="payment-img-web" style="margin-top: 10px;" src="assets/img/remove-card-from-weblg.png">
    </div>

    <h2 class="mb-60" style="margin-top: 30px;">Mobile App</h2>
    <p><strong>1.</strong>  Login to the SGC Grading App and start an order or continue a draft order.</p>
    <p><strong>2.</strong> At the end of the order, click the Payment Card option button.</p>
    <p><strong>3.</strong> On the bottom of the screen, a popup will appear with all saved payment methods, with the option to add a payment method or checkout.</p>
    <p><strong>4.</strong> On the top right corner of the popup, click the EDIT link.</p>
    <p><strong>5.</strong> Locate the payment method you want to remove, click the MINUS icon.</p>
    <p><strong>6.</strong>  A confirmation popup shall appear. To confirm removal, click the “Remove” link.</p>
    <div style="display: flex; flex-wrap: wrap; gap: 10px;">
        <img style="margin-top: 10px;" src="assets/img/mobile-remove-card-1.png">
        <img style="margin-top: 10px;" src="assets/img/mobile-remove-card-2.png">
        <img style="margin-top: 10px;" src="assets/img/mobile-remove-card-3.png">
    </div>

    <!-- <p>Per the terms of our <a routerLink="/terms">Terms and Conditions</a> and <a routerLink="/privacy">Privacy Policy</a>, you consent to receiving transactions emails; including but not limited to account signup verification, password resets, order receiving and shipping notices, and payment receipts.</p>
    <p>If you have any questions regarding unsubscribing from email marketing, please contact <a routerLink="/collector-support">Collector Support</a>.</p> -->
</div>